export default {
  REFRESH_TOKEN_CHECK_TIMEOUT: 'REFRESH_TOKEN_CHECK_TIMEOUT',
  REFRESH_TOKEN_REQUEST: "REFRESH_TOKEN_REQUEST",
  REFRESH_TOKEN_RECEIVE: "REFRESH_TOKEN_RECEIVE",
  REFRESH_TOKEN_FAILURE: "REFRESH_TOKEN_FAILURE",
  REFRESH_TOKEN_INITIAL: "REFRESH_TOKEN_INITIAL",
  REFRESH_TOKEN_CHECK: 'REFRESH_TOKEN_CHECK',
}